import { SEOHead } from "@/components/SEOHead";

interface SEOProps {
  title: string;
  description: string;
  /** Canonical path (e.g. "/salt-supply") or full URL */
  url?: string;
  /** Open Graph / Twitter share image URL */
  ogImage?: string;
  /** When true, adds noindex,nofollow */
  noIndex?: boolean;
  /** JSON-LD structured data */
  schema?: object;
}

/**
 * Thin wrapper around <SEOHead> (react-helmet-async) kept for the
 * existing per-page API. Maps the legacy props (url, schema) onto the
 * canonical/schemaJson props consumed by SEOHead.
 */
export function SEO({
  title,
  description,
  url,
  ogImage,
  noIndex,
  schema,
}: SEOProps) {
  return (
    <SEOHead
      title={title}
      description={description}
      canonical={url}
      ogImage={ogImage}
      noIndex={noIndex}
      schemaJson={schema}
    />
  );
}
